import {Component} from 'substance'

/**
 * @typedef UIButton.props
 * @property {string} label - The text of the label
 * @property {boolean} enabled - Optional, default true. Set to false to disable button
 * @property {string} icon - Font awesome class to use as an inline icon prefixed to the button text
 * @property {string} contextIcon - Font Awesome class to use as a context icon
 * @property {function} onClick - Callback for when the button is clicked
 * @property {function} onContextClick - Optional callback for when context part is clicked
 */

/**
 * @typedef UIButton.state
 * @property {bool} active - If the context button is active
 */

/**
 * Create a simple button, or a button with a context menu button, component. Use
 * `addClass()` to set `"np-ui-secondary"` for secondary colors.
 *
 * @name UIButton
 * @class
 *
 * @example
 * import {UIButton} from 'writer'
 *
 * render($$) {
 *     const el = $$('div')
 *
 *     return el.append(
 *         $$(UIButton, {
 *             label: this.getLabel('My button'),
 *             onClick: () => {
 *                 // Do something
 *             }
 *         })
 *     )
 * }
 *
 * @example
 * import {UIButton} from 'writer'
 *
 * render($$) {
 *     const el = $$('div')
 *
 *     return el.append(
 *         $$(UIButton, {
 *             label: this.getLabel('My button')
 *         })
 *         .on('click', () => {
 *             // Do something (substance event callback style)
 *         })
 *         .addClass('np-ui-secondary')
 *     )
 * }
 *
 * @param {UIButton.props} props
 * @property {UIButton.props} props
 * @property {UIButton.state} state
 */
class ButtonComponent extends Component {

    getInitialState() {
        return {
            active: false
        }
    }

    render($$) {
        let buttonContent = this.props.label

        if(this.props.icon) {
            buttonContent = [
                $$('i').addClass(`fa ${this.props.icon}`),
                $$('span').append(
                    this.props.label
                )
            ]
        }

        let buttonEl = $$('button')
            .addClass('np-ui-btn')
            .append(buttonContent)
            .on('click', evt => {
                this.onClick(evt)
            })

        if(!this.props.contextIcon) {
            if(this.props.enabled === false) {
                buttonEl.addClass('disabled')
            }

            return buttonEl
        }

        const ctxButtonEl = $$('button')
            .addClass('np-ui-btn np-ui-btn-context')
            .append(
                $$('i').addClass('fa ' + this.props.contextIcon)
            )
            .on('click', evt => {
                this.onContextClick(evt)
            })

        if(this.state.active) {
            ctxButtonEl.addClass('np-ui-btn-active')
        }

        let buttonGroupEl = $$('div')
            .addClass('np-ui-btn-group')
            .append([
                buttonEl,
                ctxButtonEl
            ])

        if(this.props.enabled === false) {
            buttonGroupEl.addClass('np-ui-disabled')
        }

        return buttonGroupEl
    }

    onClick(evt) {
        try {
            if(this.props.enabled === false) {
                return false
            }

            if(this.props.onClick) {
                return this.props.onClick(evt)
            }
        }
        catch(ex) {
        }
    }

    onContextClick(evt) {
        try {
            if(this.props.enabled === false) {
                return false
            }

            if(this.props.contextClick) {
                this.props.contextClick(evt)
            }

            // HACK: Avoid having the element detached before calculations
            setTimeout(() => {
                this.setState({
                    active: !this.state.active
                })
            }, 0)
        }
        catch(ex) {
        }

        return false
    }
}

export default ButtonComponent
